module.exports = __webpack_public_path__ + "img/ethan-profilePix.5d12ef20.jpg";